export const SET_HOROSCOPE_INFO = "SET_HOROSCOPE_INFO";
